/**
 * Redux-enabled view for the Password Reveal view (second page of the New User
 * app)
 */

import { connect } from 'react-redux';

import PurePasswordReveal from './password-reveal-view.jsx';
import { getNewUserState } from 'phoenix2/state/new-user/selectors';
import { finishViewingNewPassword } from 'phoenix2/state/new-user/actions';

const mapStateToProps = state => {
    const newUserState = getNewUserState(state);

    return {
        // The newly generated password for the user
        newPassword: newUserState.get('password'),

        // User's first name
        firstName: newUserState.get('firstName'),

        // User's last name
        lastName: newUserState.get('lastName'),

        // User's username
        username: newUserState.get('username'),
    };
};

export const mapDispatchToProps = dispatch => ({
    // Called when the user activates the finish button
    onFinish: () => dispatch(finishViewingNewPassword()),
});

export const connectPasswordRevealView = connect(mapStateToProps, mapDispatchToProps);

export const PasswordRevealView = connectPasswordRevealView(PurePasswordReveal);

PasswordRevealView.displayName = 'PasswordRevealView';
